import { apiClient } from '@/services/api';
import type { ApiResponse, UserAuthPayload } from '@/types/auth';

export interface RegisterInput {
  firstName: string;
  lastName: string;
  email: string;
  phone: string;
  password: string;
}

export interface LoginInput {
  email?: string;
  phone?: string;
  password: string;
}

class UserAuthService {
  register(input: RegisterInput) {
    return apiClient.post<ApiResponse<UserAuthPayload>>('/auth/users/register', input);
  }

  login(input: LoginInput) {
    return apiClient.post<ApiResponse<UserAuthPayload>>('/auth/users/login', input);
  }

  /** Pass the token explicitly: callers clear local storage before this request goes out. */
  logout(accessToken: string) {
    return apiClient.post<ApiResponse>('/auth/users/logout', undefined, {
      headers: { Authorization: `Bearer ${accessToken}` },
    });
  }

  forgotPassword(email: string) {
    return apiClient.post<ApiResponse>('/auth/users/forgot-password', { email });
  }

  verifyResetCode(email: string, code: string) {
    return apiClient.post<ApiResponse>('/auth/users/verify-reset-code', { email, code });
  }

  resetPassword(input: { email: string; code: string; password: string }) {
    return apiClient.post<ApiResponse>('/auth/users/reset-password', input);
  }
}

export const userAuthService = new UserAuthService();
